import { useEffect } from 'react';
import { useSettingsStore } from '../store/settingsStore';
import { ENV } from '../config/env';

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/** Sets the fixed browser tab title + SEO/OG meta for the current route. */
export function usePageMeta(title: string, description?: string, ogImage?: string) {
  const ogTitle = useSettingsStore((s) => s.ogTitle);
  const ogDesc = useSettingsStore((s) => s.ogDescription);
  const ogImg = useSettingsStore((s) => s.ogImage);

  useEffect(() => {
    document.title = 'TECNICELU S.A.';
    upsertMeta('name', 'description', description || ogDesc);
    upsertMeta('property', 'og:title', title || ogTitle);
    if (description || ogDesc) upsertMeta('property', 'og:description', description || ogDesc);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:site_name', 'TECNICELU S.A.');
    upsertMeta('name', 'twitter:card', 'summary_large_image');

    const raw = ogImage || ogImg;
    if (raw) {
      const base = raw.startsWith('http') ? raw : `${window.location.origin}${raw.startsWith('/') ? '' : '/'}${raw}`;
      const image = ENV.BUILD_ID ? `${base}${base.includes('?') ? '&' : '?'}v=${ENV.BUILD_ID}` : base;
      upsertMeta('property', 'og:image', image);
      upsertMeta('name', 'twitter:image', image);
    }
  }, [title, description, ogImage, ogTitle, ogDesc, ogImg]);
}
